import { render, staticRenderFns } from "./CardStat.vue?vue&type=template&id=0f2aa48d&scoped=true"
import script from "./CardStat.vue?vue&type=script&lang=js"
export * from "./CardStat.vue?vue&type=script&lang=js"
import style0 from "./CardStat.vue?vue&type=style&index=0&id=0f2aa48d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2aa48d",
  null
  
)

export default component.exports